import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-flow: column;
        gap: ${theme.tggSpacing(rem(2), 5)};
        align-items: center;
        max-width: ${theme.tggSpacing(rem(25.5), 63.75)};
    `}
`;

export const StyledButtonsContainer = styled('div')`
    display: flex;
    flex-flow: column;
`;

export const StyledOverlayText = styled('div')`
    text-align: center;
`;

export const IconWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${theme.tggSpacing(rem(8), 20)};
        height: ${theme.tggSpacing(rem(8), 20)};
        background-color: ${theme.palette.grey[100]};
        border-radius: 100%;
    `}
`;

export const ButtonsContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-flow: column;
        gap: ${theme.tggSpacing(rem(0.8), 3)};
        width: 100%;
    `}
`;
